module.exports = __webpack_public_path__ + "static/media/deepak_nitrite_logo.63d56796.svg";